import 'css-chunksrc/client/pages/planzoneMembersPage/resourcesMenu/groups/groupList/styles.scss';export default {
  "groupList": "_groupList_11ddx_1",
  "group": "_group_11ddx_1",
  "title": "_title_11ddx_16"
};